import Container from '@/components/container/Container';
import { CustomText } from '@/components/text/Texts';
import routes from '@/constants/routes';
import { Link } from 'react-router-dom';
import '../authentication-screens.styles.css';

const ForgotPasswordLink = () => {
	return (
		<Container className="flex justify-end w-full h-[24px]">
			<Link to={routes['/forgot-password']}>
				<CustomText
					text="Forgot password?"
					className="text-tertiary forgot-password-link"
				/>
			</Link>
		</Container>
	);
};

export default ForgotPasswordLink;
